import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import XHR from "i18next-xhr-backend";

import translationEn from "./locales/en/translation.json";
import translationAr from "./locales/ar/translation.json";

i18n
  .use(XHR)
  .use(LanguageDetector)
  .init({
    debug: false,
    fallbackLng: "ar",
    supportedLngs: ["en", "ar"],
    detection: {
      // Public URLs target Arabic search intent; an explicit saved choice can
      // still switch the interface to English.
      order: ["localStorage", "cookie", "htmlTag"],
      lookupLocalStorage: "ashursoft-language",
      lookupCookie: "ashursoft-language",
      caches: ["localStorage", "cookie"],
    },

    keySeparator: false,
    interpolation: {
      escapeValue: false,
    },

    resources: {
      en: {
        translations: translationEn,
      },
      ar: {
        translations: translationAr,
      },
    },
    ns: ["translations"],
    defaultNS: "translations",
  });

export default i18n;
